module.exports = __webpack_public_path__ + "img/PL08413.948bd306.png";